<template>
    <div class="project_py">
        <div class="information">
            <span class="information_bar"></span>
            <span class="information_zh">融媒直播</span>
            <span class="information_en">VIDEO CHANNEL</span>
            <!-- <div class="more_conent">
                <img src="../images/more.png" alt="">
                <span class="more_py">更多</span>
            </div> -->
        </div>
        <div class="videoList">

            <div class="video_module">
                <p class="video_top">
                    <i class="el-icon-video-camera-solid"></i>
                    <span>融媒直播</span>
                </p>
                <p v-if="Loading" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner
                        type="triple-bounce"></mt-spinner></p>
                <div class="video_bottom video_bottomaaa" v-if="IntegFunList == ''">
                    <div class="video_img">
                        <p style="font-size: 24px;color: #999;background:#F7F7F7;">暂无内容</p>
                    </div>
                </div>
                <div class="video_bottom" v-if="IntegFunList != ''" v-for="(item, index) in IntegFunList" :key="index"
                    @click="newsPuyang('5e9674bae4b0611cb9891062', '融媒直播')">
                    <div class="video_img" v-if="item.image_url != ''">
                        <img class="video_play" src="../images/play.png" alt="">
                        <img class="video_zhibo" :src="item.image_url" alt="">
                        <!-- <el-image class="video_zhibo" :src="item.image_url" lazy></el-image> -->
                    </div>
                    <div class="video_img" v-if="item.image_url == ''">
                        <img class="video_play" src="../images/play.png" alt="">
                        <img class="video_zhibo" src="./img/defaultimg.png" alt="">
                    </div>
                    <p class="video_intor">{{ item.title }}</p>
                </div>
            </div>
            <div class="video_module">
                <p class="video_top">
                    <i class="el-icon-video-camera-solid"></i>
                    <span>视频新闻</span>
                </p>
                <p v-if="Loadingspxw" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner
                        type="triple-bounce"></mt-spinner></p>
                <div class="video_bottom" v-for="(item, index) in shufflingFunList" :key="index"
                    @click="newsPuyang('5da14b3de4b0f0e6b01f37ab', '视频新闻')">
                    <div class="video_img">
                        <img class="video_play" src="../images/play.png" alt="">
                        <img class="video_zhibo" :src="item.image_url" alt="">
                        <!-- <el-image class="video_zhibo" :src="item.image_url" lazy></el-image> -->
                    </div>
                    <p class="video_intor">{{ item.title }}</p>
                </div>
            </div>
            <div class="video_module">
                <p class="video_top">
                    <i class="el-icon-video-camera-solid"></i>
                    <span>短视频</span>
                </p>
                <p v-if="Loadingdss" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner
                        type="triple-bounce"></mt-spinner></p>
                <div class="video_bottom" v-for="(item, index) in videoFunList" :key="index"
                    @click="newsPuyang('5cc57db80cf2c3d1b7e9d4e0', '短视频')">
                    <div class="video_img">
                        <img class="video_play" src="../images/play.png" alt="">
                        <img class="video_zhibo" :src="item.image_url" alt="">
                        <!-- <el-image class="video_zhibo" :src="item.image_url" lazy></el-image> -->
                    </div>
                    <p class="video_intor">{{ item.title }}</p>
                </div>
            </div>
            <!-- <div class="video_module">
               <p class="video_top">
                   <i class="el-icon-video-camera-solid"></i>
                   <span>短视频</span>
               </p>
               <div class="video_bottom">
                   <div class="video_img">
                        <img class="video_play" src="../images/play.png" alt="">
                        <img class="video_zhibo" src="../images/zhibo.jpg" alt="">
                   </div>
                   <p class="video_intor">印度空军出动该国最大运输机向武汉运 送15吨医疗物资</p>
               </div>
           </div> -->
            <div class="video_module">
                <p class="video_top">
                    <i class="el-icon-video-camera-solid"></i>
                    <span>短视频</span>
                </p>
                <p v-if="Loadingdss" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner
                        type="triple-bounce"></mt-spinner></p>
                <div class="video_bottom" v-for="(item, index) in videoFunListTwo" :key="index"
                    @click="newsPuyang('5cc57db80cf2c3d1b7e9d4e0', '短视频')">
                    <div class="video_img">
                        <img class="video_play" src="../images/play.png" alt="">
                        <img class="video_zhibo" :src="item.image_url" alt="">
                        <!-- <el-image class="video_zhibo" :src="item.image_url" lazy></el-image> -->
                    </div>
                    <p class="video_intor">{{ item.title }}</p>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { listApi, generateSign } from '@/api/index'
import Bus from '@/Bus'

const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5da14b3de4b0f0e6b01f37ab",
    userId: "",
    appInfoId: "10"
}

const videoParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5cc57db80cf2c3d1b7e9d4e0",
    userId: "",
    appInfoId: "10"
}

const IntegratingMedia = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5e9674bae4b0611cb9891062",
    userId: "",
    appInfoId: "10"
}
export default {
    data() {
        return {
            Loading: true,
            Loadingspxw: true,
            Loadingdss: true,
            jumpRouting: true,
            // 视频新闻
            shuParameter: Object.assign({}, shufflingParameter),
            shufflingFunList: null,
            shufflingPicture: [],
            // 短视频
            shortParameter: Object.assign({}, videoParameter),
            videoFunList: null,
            videoFunListTwo: null,
            videoPicture: [],
            // 影视频道
            IntegParameter: Object.assign({}, IntegratingMedia),
            IntegFunList: null,
            IntegPicture: []
        }
    },
    created() {
        this.shufflingFun()
        this.videoFun()
        this.IntegFun()
    },
    methods: {
        async shufflingFun() {
            const headers = {
                'Sign': generateSign()
            };
            const res = await this.axios.post(listApi, this.shuParameter, { headers })
            this.shufflingFunList = res.data.data[0].list.splice(0, 1)
            this.Loadingspxw = false
        },

        async videoFun() {
            const headers = {
                'Sign': generateSign()
            };
            const res = await this.axios.post(listApi, this.shortParameter, { headers })
            this.videoFunList = res.data.data[0].list.splice(0, 1)
            this.videoFunListTwo = res.data.data[0].list.splice(0, 1)
            this.Loadingdss = false
        },

        async IntegFun() {
            const headers = {
                'Sign': generateSign()
            };
            const res = await this.axios.post(listApi, this.IntegParameter, { headers })
            this.IntegFunList = res.data.data[0].list.splice(0, 1)
            this.Loading = false
        },

        // 获取濮阳新闻更多列表
        newsPuyang(columnId, title) {
            let routeData = this.$router.resolve({ path: '/contentList', query: { columnId, title } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false);
        },

        shufflingPicFun(type) {
            let routeData = this.$router.resolve({ path: '/details', query: { id: type.id, jsonUrl: type.jsonUrl } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false);
        }
    }
}
</script>
<style lang="">
    .project_py{
        margin-top:44px;
        border-top:2px solid rgba(201,3,4,1);
    }
    .project_py .information{
        height:45px;
        line-height:45px;
        border-bottom:1px solid rgba(210,210,210,1);;
    }
    .information  .information_bar{
        margin:0 10px 0 16px;
        border-left:3px solid rgba(201,3,4,1);
    }
    .information .information_zh{
         height:18px;
         color:rgba(201,3,4,1);
         font-size:18px;
         font-weight: bolder;
    }
    .information .information_en{
        font-size: 18px;
        color:#646464;
        font-weight: 400;
        margin-left:10px;
    }
    .more_conent{
        width:60px;
        float:right;
    }
    .more_conent .more_py{
        font-size: 12px;
        font-weight: 400;
        width:28px;
        float:right;
        color:#969696;
    }
    .more_conent img{
        width:14px;
        height:14px;
        float:right;
        padding-top:15px;
        cursor:pointer; 
        padding-right: 6px;
    }
    .videoList{
        height:300px;
    }
    .videoList .video_module{
        width:280px;
        float:left;
        margin-right:26px;
    }
    .videoList .video_module:last-child{
        margin:0;
    }
    .videoList .video_module .video_top{
        height:50px;
        margin-top:10px;
        line-height:50px;
        text-align: center;
    }
    .videoList .video_module .video_top i{
        color:#C81A1B;
        font-size: 26px;
    }
    .videoList .video_module .video_top span{
        font-size: 16px;
        font-weight: bolder;
        color:#333333;
    }
    .video_bottomaaa{
        cursor:pointer; 
        width:240px;
        height:200px;
        padding:20px;
        background:#fff !important;
    }
    .videoList .video_module .video_bottom{
        cursor:pointer; 
        width:240px;
        height:200px;
        padding:20px;
        background:#F7F7F7;
    }
    .videoList .video_module .video_bottom .video_intor{
        margin-top:18px;
        font-size: 16px;
        color:#333333;
        line-height:20px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .videoList .video_module .video_bottom .video_img{
        position:relative;
        width:240px;
        height:152px;
        cursor:pointer; 
        line-height:152px;
        text-align: center;
    }
    .video_bottom .video_img .video_play{
        width:40px;
        height:40px;
        position:absolute;
        z-index: 99;
        top:56px;
        left:100px;
    }
    .videoList .video_module .video_bottom .video_img .video_zhibo{
        position:absolute;
        width:100%;
        height:100%;
        position:absolute;
        left:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/videoChannel.vue